export default __webpack_public_path__ + "static/media/logo.2dda9ed8.png";